// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.simple-keyboard.fb-keyboard {
  background-color: transparent;
  border: none;
  box-shadow: none;
  padding: 0;
}

/** Rows style for the default theme. */
.simple-keyboard.fb-keyboard .hg-rows {
  gap: 8px;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
}

.simple-keyboard.fb-keyboard .hg-rows .hg-row {
  margin-bottom: 0px;
}

/** Button style for the default theme. */
.simple-keyboard.fb-keyboard .hg-rows .hg-row .hg-button {
  height: 64px;
  border-bottom: 0;
  border-radius: 4px;
  box-shadow: 0 2px 6px rgba(207, 216, 222, 0.65) !important;
}

.simple-keyboard.fb-keyboard .hg-rows .hg-row .hg-button.hg-activeButton {
  box-shadow: none !important;
  opacity: 0.5;
  background-color: #ffffff;
}

/** Caps lock indicator: while the shift layout is active, tint the shift key's SVG icon with the theme primary (brand) color. */
.simple-keyboard.fb-keyboard .hg-rows .hg-row .hg-button.active {
  filter: brightness(0.95) !important;
}

.simple-keyboard.fb-keyboard .hg-rows .hg-row .hg-button.active svg path {
  fill: var(--color-brand-600);
}

.simple-keyboard.fb-keyboard .hg-rows .hg-row .hg-button:not(:last-child) {
  margin-right: 8px;
}

.simple-keyboard.fb-keyboard .hg-rows .hg-row .hg-button span {
  font-size: 24px;
}

/** Candidate box style for the default theme. */
.simple-keyboard.fb-keyboard .hg-candidate-box {
  zoom: 1.2;
}

.simple-keyboard.fb-keyboard:not(.paginated-candidates) .hg-candidate-box .hg-candidate-box-prev,
.simple-keyboard.fb-keyboard:not(.paginated-candidates) .hg-candidate-box .hg-candidate-box-next {
  display: none;
}

.hg-candidate-box-list-item {
  padding: 0 12px !important;
  width: auto !important;
}

.hg-candidate-box-list-item.selected {
  position: relative;
}

.hg-theme-default .hg-button.hg-standardBtn[data-skbtn="@"] {
  max-width: unset!important;
}

.hg-candidate-box-list-item.selected::before {
  content: ' ';
  position: absolute;
  top: 5px;
  height: calc(100% - 10px);
  width: calc(100% - 10px);
  background: #d1d5db;
  border-radius: 3px;
  z-index: 1;
  mix-blend-mode: darken;
}

/** Disabled button style */
.simple-keyboard.fb-keyboard .hg-rows .hg-row .hg-button.disabled {
  opacity: 0.3;
  pointer-events: none;
}

.keyboard-input-caret {
  display: inline-block;
  width: 2px;
  height: 1em;
  vertical-align: middle;
  background-color: currentColor;
  animation: keyboard-input-caret-blink 1s step-start infinite;
}

@keyframes keyboard-input-caret-blink {
  50% {
    opacity: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Keyboard/index.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;;AAEA,uCAAuC;AACvC;EACE,QAAQ;EACR,aAAa;EACb,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,yCAAyC;AACzC;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,0DAA0D;AAC5D;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,yBAAyB;AAC3B;;AAEA,gIAAgI;AAChI;EACE,mCAAmC;AACrC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA,gDAAgD;AAChD;EACE,SAAS;AACX;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,yBAAyB;EACzB,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,sBAAsB;AACxB;;AAEA,2BAA2B;AAC3B;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,8BAA8B;EAC9B,4DAA4D;AAC9D;;AAEA;EACE;IACE,UAAU;EACZ;AACF","sourcesContent":[".simple-keyboard.fb-keyboard {\n  background-color: transparent;\n  border: none;\n  box-shadow: none;\n  padding: 0;\n}\n\n/** Rows style for the default theme. */\n.simple-keyboard.fb-keyboard .hg-rows {\n  gap: 8px;\n  display: flex;\n  flex-wrap: nowrap;\n  flex-direction: column;\n}\n\n.simple-keyboard.fb-keyboard .hg-rows .hg-row {\n  margin-bottom: 0px;\n}\n\n/** Button style for the default theme. */\n.simple-keyboard.fb-keyboard .hg-rows .hg-row .hg-button {\n  height: 64px;\n  border-bottom: 0;\n  border-radius: 4px;\n  box-shadow: 0 2px 6px rgba(207, 216, 222, 0.65) !important;\n}\n\n.simple-keyboard.fb-keyboard .hg-rows .hg-row .hg-button.hg-activeButton {\n  box-shadow: none !important;\n  opacity: 0.5;\n  background-color: #ffffff;\n}\n\n/** Caps lock indicator: while the shift layout is active, tint the shift key's SVG icon with the theme primary (brand) color. */\n.simple-keyboard.fb-keyboard .hg-rows .hg-row .hg-button.active {\n  filter: brightness(0.95) !important;\n}\n\n.simple-keyboard.fb-keyboard .hg-rows .hg-row .hg-button.active svg path {\n  fill: var(--color-brand-600);\n}\n\n.simple-keyboard.fb-keyboard .hg-rows .hg-row .hg-button:not(:last-child) {\n  margin-right: 8px;\n}\n\n.simple-keyboard.fb-keyboard .hg-rows .hg-row .hg-button span {\n  font-size: 24px;\n}\n\n/** Candidate box style for the default theme. */\n.simple-keyboard.fb-keyboard .hg-candidate-box {\n  zoom: 1.2;\n}\n\n.simple-keyboard.fb-keyboard:not(.paginated-candidates) .hg-candidate-box .hg-candidate-box-prev,\n.simple-keyboard.fb-keyboard:not(.paginated-candidates) .hg-candidate-box .hg-candidate-box-next {\n  display: none;\n}\n\n.hg-candidate-box-list-item {\n  padding: 0 12px !important;\n  width: auto !important;\n}\n\n.hg-candidate-box-list-item.selected {\n  position: relative;\n}\n\n.hg-theme-default .hg-button.hg-standardBtn[data-skbtn=\"@\"] {\n  max-width: unset!important;\n}\n\n.hg-candidate-box-list-item.selected::before {\n  content: ' ';\n  position: absolute;\n  top: 5px;\n  height: calc(100% - 10px);\n  width: calc(100% - 10px);\n  background: #d1d5db;\n  border-radius: 3px;\n  z-index: 1;\n  mix-blend-mode: darken;\n}\n\n/** Disabled button style */\n.simple-keyboard.fb-keyboard .hg-rows .hg-row .hg-button.disabled {\n  opacity: 0.3;\n  pointer-events: none;\n}\n\n.keyboard-input-caret {\n  display: inline-block;\n  width: 2px;\n  height: 1em;\n  vertical-align: middle;\n  background-color: currentColor;\n  animation: keyboard-input-caret-blink 1s step-start infinite;\n}\n\n@keyframes keyboard-input-caret-blink {\n  50% {\n    opacity: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
